import axios from 'axios';
import queryString from 'query-string';
import { queryStringifyOptions } from 'utils/constants';

// withUpload parameter is necessary only for Attestation sur honneur
// when withUpload=false it retrieves the template for the Attestation sur honneur
// when withUpload=true it retrieves the last file uploaded
// for other types withUpload can be omitted
export const downloadDocument = ({ type, withUpload, subscriptionId }) =>
    axios.get(
        `/documents/download?${queryString.stringify(
            { type, withUpload, subscriptionId },
            queryStringifyOptions
        )}`,
        { responseType: 'arraybuffer' }
    );
export const downloadDocumentById = (id, isAudit = false) =>
    isAudit
        ? axios.get(`/document_audits/download/${id}`, { responseType: 'arraybuffer' })
        : axios.get(`/documents/download/${id}`, { responseType: 'arraybuffer' });
export const generatePEC = payload =>
    axios.post('/payments/pec', payload, { responseType: 'arraybuffer' });
export const removeDocuments = payload => axios.delete('/documents/multi', { data: payload });
export const sendDocuments = payload =>
    axios.post('/documents/multi', payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
export const replaceDocument = (id, payload) =>
    axios.post(`/documents/replace/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
